module.exports = __webpack_public_path__ + "static/img/done-start-guide.16a4e3fc.svg";